import { useLocation, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import qs from 'qs';
import { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { CODE_GROUP_ID, ROLE } from '../../../constant/Constant';
import InputBox from '../../../component/InputBox';
import ModalRef from '../../../component/ModalRef';
import { modalType } from '../../../util/ModalUtil';
import UserWithdrawalModal from '../../modal/UserWithdrawalModal';
import UserPrivateInfoModal from '../../modal/UserPrivateInfoModal';
import { HOME_PATH } from '../../../constant/Constant';
import {
    actionUserInfoPassword,
    actionUserInfoBaseEdit,
    actionUserInfoBaseSearch,
} from '../../../module/body/main/UserInfoModule';
import CancelButtonBox from '../../../component/buttons/CancelButtonBox';
import ConfirmButtonBox from '../../../component/buttons/ConfirmButtonBox';
import { BlueBorderButtonBox, RedBorderButtonBox } from '../../../component/buttons/CustomButtonBox';
import PopupRef from '../../../component/PopupRef';
import CodeUtil from '../../../util/CodeUtil';
import { actionLogout } from '../../../module/LoginModule';
import NullCheckUtil from '../../../util/NullCheckUtil';
import AuthenticationUtil from '../../../util/AuthenticationUtil';
import TelNoInputBox from '../../../component/TelNoInputBox';
import PasswordInputRefreshBox from '../../../component/PasswordInputRefreshBox';

const UserInfoView = () => {
    const location = useLocation();
    const queryData = qs.parse(location.search, { ignoreQueryPrefix: true });
    const [userId, setuserId] = useState(queryData.userId);
    const [originPassword, setOriginPassword] = useState('');
    const [password, setPassword] = useState('');
    const [isPassword, setIsPassword] = useState(false);
    const [passwordConfirm, setPasswordConfirm] = useState('');
    const [isPasswordConfirm, setIsPasswordConfirm] = useState(false);
    const [passwordMessage, setPasswordMessage] = useState('');
    const [passwordConfirmMessage, setPasswordConfirmMessage] = useState('');

    const [userRoleCd, setUserRoleCd] = useState(AuthenticationUtil.getUserRoleCd);

    const [universityCd, setUniversityCd] = useState('');
    const [universityNm, setUniversityNm] = useState('');
    const [majorDeptNm, setMajorDeptNm] = useState('');
    const [studentId, setStudentId] = useState('');
    const [userNm, setUserNm] = useState('');
    const [telNo, setTelNo] = useState('');

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const { result } = useSelector((state) => state.userInfoState);

    // modal Ref
    const modalRef = useRef(null);
    const popupRef = useRef(null);

    useEffect(() => {
        if (userId) {
            dispatch(actionUserInfoBaseSearch({ userId }));
        }
    }, []);

    useEffect(() => {
        setMajorDeptNm(result.majorDeptNm);
        setStudentId(result.studentId);
        setUserNm(result.userNm);
        setTelNo(result.telNo);
        setUniversityCd(result.userUniversityCd);
        setUniversityNm(ROLE.ADMIN == userRoleCd ? '시스템 관리자' : result.userUniversityNm);
    }, [result]);

    const inputValidation = () => {
        if (NullCheckUtil.isEmpty(originPassword)) {
            popupRef.current.openAlert('이전 비밀번호를 입력해주세요.');
            return false;
        } else if (NullCheckUtil.isEmpty(password) || !isPassword) {
            popupRef.current.openAlert('화면의 비밀번호 오류메시지를 확인 해주세요.');
            return false;
        } else if (NullCheckUtil.isEmpty(passwordConfirm) || !isPasswordConfirm) {
            popupRef.current.openAlert('화면의 비밀번호 오류메시지를 확인 해주세요.');
            return false;
        } else if (originPassword === password) {
            popupRef.current.openAlert('이전 비밀번호와 같은 비밀번호로 수정할 수 없습니다. 다시 입력해 주세요.');
            return false;
        } else {
            return true;
        }
    };

    const handlePasswordConfirm = () => {
        if (inputValidation()) {
            dispatch(
                actionUserInfoPassword({
                    data: {
                        userId,
                        pswd: btoa(originPassword),
                        newPswd: btoa(password),
                    },
                    callback: () => {
                        popupRef.current.openInfo('정상 처리 되었습니다.', () => {
                            return function () {
                                setOriginPassword('');
                                setPassword('');
                                setPasswordConfirm('');
                                setPasswordMessage('');
                                setPasswordConfirmMessage('');
                            };
                        });
                    },
                }),
            );
        }
    };

    const handleBaseConfirm = () => {
        if (ROLE.ADMIN != userRoleCd && NullCheckUtil.isEmpty(universityCd)) {
            popupRef.current.openAlert('소속대학을 확인해주세요.');
        } else if (ROLE.STUDENT == userRoleCd && NullCheckUtil.isEmpty(majorDeptNm)) {
            popupRef.current.openAlert('전공(학과)를 입력해주세요.');
        } else if (ROLE.STUDENT == userRoleCd && NullCheckUtil.isEmpty(studentId)) {
            popupRef.current.openAlert('학번을 입력해주세요.');
        } else if (NullCheckUtil.isEmpty(userNm)) {
            popupRef.current.openAlert('이름을 입력해주세요.');
        } else if (NullCheckUtil.isEmpty(telNo)) {
            popupRef.current.openAlert('전화번호를 입력해주세요.');
        } else {
            dispatch(
                actionUserInfoBaseEdit({
                    userId,
                    universityCd,
                    majorDeptNm,
                    studentId,
                    userNm,
                    telNo,
                    popupRef,
                    callback: () => {
                        popupRef.current.openInfo('정상 처리 되었습니다.', () => {
                            return function () {
                                window.location.reload();
                            };
                        });
                    },
                }),
            );
        }
    };

    const handleCancel = () => {
        //TODO
        navigate(-1);
    };

    const handleToPrivateInfo = (params) => {
        modalRef.current.open(
            <UserPrivateInfoModal type={modalType.DETAIL} modalRef={modalRef} invisibleCheckbox={true} />,
            'large',
        );
    };

    const handleToUserWithdrawal = (params) => {
        modalRef.current.open(
            <UserWithdrawalModal
                modalRef={modalRef}
                callback={() => {
                    modalRef.current.close();
                    popupRef.current.openInfo('탈퇴 처리 되었습니다.', () => {
                        return function () {
                            dispatch(actionLogout({ data: { forceLogout: true }, msg: '로그아웃 하였습니다.' }));
                            navigate(HOME_PATH);
                        };
                    });
                }}
                userId={userId}
            />,
            'small',
        );
    };

    const changeStudentId = (value) => {
        const onlyNumber = value.replace(/[^0-9]/g, '');
        setStudentId(onlyNumber);
    };

    return (
        <section className='container'>
            <div className='container-inner'>
                <div className='user-wrap'>
                    <div className='join-top'>
                        <h2 className='join-tit'>회원정보</h2>
                    </div>
                    <div className='user-info-set'>
                        <div className='my-id'>
                            <div className='user-id-box'>
                                <div className='id-label'>아이디</div>
                                <div className='id-data'>{userId}</div>
                            </div>
                        </div>
                        <div className='my-pw'>
                            <h3 className='sub-tit'>비밀번호 변경</h3>
                            <InputBox
                                title='이전 비밀번호'
                                value={originPassword}
                                password
                                onChange={(e) => setOriginPassword(e.target.value)}
                            />
                            <PasswordInputRefreshBox
                                password={password}
                                setPassword={setPassword}
                                setIsPassword={setIsPassword}
                                passwordConfirm={passwordConfirm}
                                setPasswordConfirm={setPasswordConfirm}
                                setIsPasswordConfirm={setIsPasswordConfirm}
                                passwordMessage={passwordMessage}
                                setPasswordMessage={setPasswordMessage}
                                passwordConfirmMessage={passwordConfirmMessage}
                                setPasswordConfirmMessage={setPasswordConfirmMessage}
                            />
                            <div className='info-btn-box btn-wrap'>
                                <CancelButtonBox title='취소' onClick={(e) => handleCancel()} />
                                <ConfirmButtonBox title='확인' onClick={(e) => handlePasswordConfirm()} />
                            </div>
                        </div>
                        <div className='my-basic-info'>
                            <h3 className='sub-tit'>기본 정보 수정</h3>
                            <div className='personal-info-box'>
                                <div className='info-form-wrap'>
                                    {AuthenticationUtil.getUserRoleCd() != ROLE.STUDENT && (
                                        <>
                                            <div className='info-form-row'>
                                                <InputBox title='소속대학' value={universityNm} disabled />
                                                <InputBox
                                                    title='이름'
                                                    value={userNm}
                                                    onChange={(e) => setUserNm(e.target.value)}
                                                />
                                                <TelNoInputBox title='연락처' value={telNo} setTelNo={setTelNo} />
                                            </div>
                                        </>
                                    )}
                                    {AuthenticationUtil.getUserRoleCd() == ROLE.STUDENT && (
                                        <>
                                            <div className='info-form-row'>
                                                <InputBox title='소속대학' value={universityNm} disabled />
                                                <InputBox
                                                    title='전공(학과)'
                                                    value={majorDeptNm}
                                                    onChange={(e) => setMajorDeptNm(e.target.value)}
                                                />
                                                <InputBox
                                                    title='학번'
                                                    value={studentId}
                                                    onChange={(e) => changeStudentId(e.target.value)}
                                                />
                                            </div>
                                            <div className='info-form-row'>
                                                <InputBox
                                                    title='이름'
                                                    value={userNm}
                                                    onChange={(e) => setUserNm(e.target.value)}
                                                />
                                                <TelNoInputBox title='휴대전화' value={telNo} setTelNo={setTelNo} />
                                            </div>
                                        </>
                                    )}
                                </div>
                            </div>
                            <div className='info-btn-box btn-wrap'>
                                <CancelButtonBox title='취소' onClick={(e) => handleCancel()} />
                                <ConfirmButtonBox title='확인' onClick={(e) => handleBaseConfirm()} />
                            </div>
                        </div>
                        {userRoleCd === ROLE.STUDENT && (
                            <div className='my-info-used'>
                                <h3 className='sub-tit'>개인 정보 이용내역</h3>
                                <BlueBorderButtonBox title='조회' onClick={(e) => handleToPrivateInfo()} />
                            </div>
                        )}
                        {userRoleCd === ROLE.STUDENT && (
                            <div className='user-withdrawal'>
                                <h3 className='sub-tit'>회원 탈퇴</h3>
                                <RedBorderButtonBox title='회원탈퇴' onClick={(e) => handleToUserWithdrawal()} />
                            </div>
                        )}
                    </div>
                </div>
            </div>
            <ModalRef ref={modalRef} />
            <PopupRef ref={popupRef} />
        </section>
    );
};

export default UserInfoView;
